import { loadResultWithData } from './Viewer/Results/LoadResults';
import { AbLoads } from './Viewer/LoadExam/AbLoads';
import { loadTests } from './Pages/TestList';
import { loadTestEditor } from './Pages/TestEditor';
import { loadCodeManagement } from './Pages/ActivationCodes';
import { loadTutorCourseManagement } from './Pages/TutorCourseManagement';
import { loadAdminCourseManagement } from './Pages/AdminCourseManagement';
import { loadTutorManagement } from './Pages/TutorManager';
import { loadAdminAbManagement } from './Pages/AdminAbManagement';
import { loadInstanceManagement } from './Pages/InstanceManagement';
import { loadHome } from './Pages/Home';
import { loadTest } from './Pages/Test';
import { loadEditor } from './Pages/Editor';
import { loadTaskManagement } from './Pages/TaskManagement';
import { loadResult } from './Pages/Result';
import { loadPlans } from './Pages/Subscriptions';
import { loadContract } from './Pages/Contract';
import { loadInbox } from './Pages/Inbox';
import { loadPrinter } from './Pages/Printing';
import { loadProfile } from './Pages/Profile';
import { loadFeatureUpvotes } from './Pages/Features';
import { loadRegistration } from './Pages/Registration';
import { loadCodeActivator } from './Pages/CodeActivation';
import { loadUserManagement } from './Pages/UserManagement';
import { loadSubmissions } from './Pages/Submissions';
import { loadInstanceSetup } from './Pages/InstanceSetup';
import { loadCourseSetup } from './Pages/CourseSetup';
import { loadImporter } from './Pages/Importer';
import { authFunctionality } from './Utils/Auth';
import { loadCoursePage } from './Pages/Course';
import { loadAssignment } from './Pages/Assignments';
import { loadPasswordReset } from './Pages/ResetPassword';
import { loadUserReset } from './Pages/ResetUser';
import { loadAssignmentOverview } from './Pages/Assignments/overviewIndex';
import { loadGoToAbListener } from './Pages/Home/loadAb';


export default (): void => {
  window.PexamTasks = class PexamTasks {
      constructor() {

      }

      // initEditor(){
      //   tinymce.PluginManager.add('standard-inputs', setup);
      //   activations();
      // }

      // initConverter(){ // TODO: FIX IF EVER NEEDED AGAIN
      //   window.converter = converter;
      //   initConverter();
      // }

      // initPrint():void {
      //   AbLoads();
      //   showPrint();
      // }

      // initAb():void {
      //   AbLoads();
      //   loadExam();
      // }

      // loadResults(testNr:number):void {
      //   AbLoads();
      //   loadResults(testNr);
      // }

      loadResultsWithData(data):void {
        AbLoads();
        loadResultWithData(data);
      }

  }


  const url = window.location.pathname;
  console.log(url);

  // always load auth functionality
  authFunctionality()
  loadGoToAbListener() // load from anywhere
  // Tutor
  if (url.startsWith('/tests')){
    loadTests()
  } else if (url.startsWith('/test-editor')){
    loadTestEditor()
  } else if (url.startsWith('/code-management')){
    loadCodeManagement()
  } else if (url.startsWith('/course-management/tutor')){
    loadTutorCourseManagement()
  } else if (url.startsWith('/kurs-verwaltung')){ // Admin
    loadAdminCourseManagement()
  } else if (url.startsWith('/tutor-verwaltung')){
    loadTutorManagement()
  } else if (url.startsWith('/ab-verwaltung')){
    loadAdminAbManagement()
  } else if (url.startsWith('/instanz-verwaltung')){
    loadInstanceManagement()
  } else if (url.startsWith('/home')){
    loadHome()
  } else if (url.startsWith('/ab/')){
    loadTest()
  } else if (url.startsWith('/ab-aufrufen')){
    loadTest()
  } else if (url.startsWith('/editor/')){
    loadEditor()
  } else if (url.startsWith('/aufgaben')){
    loadTaskManagement()
  } else if (url.startsWith('/antwort/')){
    loadResult()
  } else if (url.startsWith('/plans')){
    loadPlans()
  } else if (url.startsWith('/contract/')){
    loadContract()
  } else if (url.startsWith('/inbox')){
    loadInbox()
  } else if (url.startsWith('/drucken')){
    loadPrinter()
  } else if (url.startsWith('/profil')){
    loadProfile()
  } else if (url.startsWith('/feature')){
    // for both /feature and /features
    loadFeatureUpvotes()
  } else if (url.startsWith('/regist')){
    loadRegistration()
  } else if (url.startsWith('/code/')){
    loadCodeActivator()
  } else if (url.startsWith('/user-management')){
    loadUserManagement()
  } else if (url.startsWith('/submissions')){
    loadSubmissions()
  } else if (url.startsWith('/antworten/')){
    loadSubmissions()
  } else if (url.startsWith('/setup-instance')){
    loadInstanceSetup() 
  } else if (url.startsWith('/setup-course')){
    loadCourseSetup()
  } else if (url.startsWith('/import')){
    loadImporter()
  } else if (url.startsWith('/kurs')){
    loadCoursePage()
  } else if (url.startsWith('/assignments/')){
    loadAssignmentOverview()
  } else if (url.startsWith('/assignment')){
    loadAssignment()
  } else if (url.startsWith('/reset-password')){
    loadPasswordReset()
  } else if (url.startsWith('/reset-user/')){
    loadUserReset()
  }
}